var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-container"},[(_vm.img)?_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":_vm.img,"width":"70px","alt":""}})]):_vm._e(),_c('div',{staticClass:"description"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))])]),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }